import { Injectable } from '@angular/core';

@Injectable()
export class FlashMessage {
  private component = null;

  public show(...args) {
    if (!this.component) return;
    return this.component.show(...args);
  }

  public clear(...args) {
    if (!this.component) return;
    return this.component.clear(...args);
  }

  public registerComponent(component) {
    this.component = component;
  }
}
